export default "__VITE_ASSET__SIKBvTJh__"